module.exports = __webpack_public_path__ + "img/杭州电子科技大学LOGO.f0000e59.png";